import { ApiCurrency } from 'data/Currencies/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const fetchCurrencies = (type) =>
  fetchApi<{ currencies: ApiCurrency[] }>({
    method: 'GET',
    url: getApiUrl(`assets/currencies/${type}`)
  })
